import { render, staticRenderFns } from "./querybill.vue?vue&type=template&id=845ab606&scoped=true&"
import script from "./querybill.vue?vue&type=script&lang=js&"
export * from "./querybill.vue?vue&type=script&lang=js&"
import style0 from "./querybill.vue?vue&type=style&index=0&id=845ab606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845ab606",
  null
  
)

export default component.exports